export default angular.module('cian.newbuild.serpViewMode', [])
  .factory('SerpViewMode', ['$window', '$rootScope', ($window, $rootScope) => {
    const service = {};

    const currentMode = $window._serpViewMode;

    const modes = {
      // true, если вид доступен
      list: true,
      table: $window._showModeSwitcher,
    };

    // Текущий вид выдачи
    service.currentModeIs = mode => currentMode === mode;
    service.isTable = service.currentModeIs('table');
    service.isList = service.currentModeIs('list');

    // Доступность вида выдачи
    service.setModeAvailability = (mode, isAvailable) => modes[mode] = isAvailable;
    service.isModeAvailable = mode => modes[mode];

    service.getMode = () => currentMode;

    service.setMode = mode => {
      if (mode === currentMode) return;

      // Трекаем аналитику
      const [fromMode, toMode] = [currentMode.toUpperCase(), mode.toUpperCase()];
      ca('event', {
        name: 'oldevent',
        category: 'Skin',
        action: toMode,
        label: fromMode
      });

      if (mode !== 'map') {
        $rootScope.offersLoading = true; // включаем прелоадер

        const COOKIE_DAYS = 365;
        const expire = new Date();
        expire.setTime(expire.getTime() + (COOKIE_DAYS * 24 * 60 * 60 * 1000));
        $window.document.cookie = `serp_view_mode=${mode}; path=/; domain=.cian.ru; expires=${expire.toUTCString()}`;
        $window.location.reload(true);
      }
    };

    return service;
  }])
  .name;



// WEBPACK FOOTER //
// ./src/serp/services/serp-view-mode.service.js